import * as React from "react";
import { SVGProps, memo } from "react";
const SvgTableCertified14Px = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={14}
    role="img"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path
        fill="#BFBFBF"
        d="M5 4v2h2v1H5v2h1v1H5v2H4v-2H1V9h3V7H1V6h3V4h1Zm4 0v2H8V4h1Z"
      />
      <path
        fill="#666"
        d="M12 0a1 1 0 0 1 1 1v5h-1V4H1v8h5v1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h11Zm0 1H1v2h11V1Z"
      />
      <circle cx={10.5} cy={10.5} r={3.5} fill="#008057" />
      <path
        fill="#FFF"
        d="m11.787 8.54.794.437-1.98 3.608a.45.45 0 0 1-.132.147l-.073.042-.016.007a.455.455 0 0 1-.507-.083l-1.645-1.554.631-.647 1.226 1.153 1.702-3.11Z"
      />
    </g>
  </svg>
);
const Memo = memo(SvgTableCertified14Px);
export default Memo;
